import BaseStore from 'customer-flows/stores/base-store'
import { tracked } from '@glimmer/tracking'

export default class OrderStoreClass extends BaseStore {
  @tracked order?: Order

  get orderId() {
    return this.order?.id
  }

  get primarySale(): Booking {
    return this.order?.sales?.[0] as Booking
  }

  get displayId() {
    return this.order?.displayId
  }
}

declare global {
  export type OrderStore = OrderStoreClass

  export interface StoreRegistry {
    order: OrderStoreClass
  }
}
